import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

const Switch = ({
  name,
  checked,
  disabled,
  className,
  onChange,
  ...otherProps
}) => {
  const classNames = [styles.switch, className];

  if (disabled) {
    classNames.push(styles.disabled);
  }
  if (checked) {
    classNames.push(styles.active);
  }

  return (
    <span
      className={classNames.join(' ')}
      role="checkbox"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={0}
      {...otherProps}
    >
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        tabIndex={-1}
      />

      <div className={styles.switchBase}>
        <div className={styles.track} />
        <div className={styles.thumb} />
      </div>
    </span>
  );
};

Switch.defaultProps = {
  checked: false,
  disabled: false,
  className: null,
  onChange: () => {}
};

Switch.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};

export default Switch;
